import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";
import { useTranslation } from "react-i18next";

const filterA5DerivativeUnderlyingsSchema = z.object({
  structured_product_id_equals: z.coerce.number().nullable().optional(),
  structured_product_name_contains: z.preprocess(
    preprocessTextAsyncAutocompleteField,
    z.union([
      // we recv / send as string the data
      z.string().optional().nullable(),
      // for the autocomplete, the form state is an object
      z.object({
        id: z.number(),
        text: z.string(),
      }),
    ]),
  ),
  underlying_id_equals: z.coerce.number().nullable().optional(),
  underlying_name_contains: z.preprocess(
    preprocessTextAsyncAutocompleteField,
    z.union([
      // we recv / send as string the data
      z.string().optional().nullable(),
      // for the autocomplete, the form state is an object
      z.object({
        id: z.number(),
        text: z.string(),
      }),
    ]),
  ),
  created_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterA5DerivativeUnderlyingsSchema = z.infer<
  typeof filterA5DerivativeUnderlyingsSchema
>;

const client = "a5";

export function FilterA5DerivativeUnderlyings() {
  const { t } = useTranslation("tables");
  const fields: Field[] = [
    {
      name: "structured_product_name_contains",
      label: t("a5_derivative_underlyings.searchbox.structured_product_name_contains", { defaultValue: "Structured product" }),
      type: "asyncAutocomplete",
      base_url: "a5/a5_static_data",
      column_name: "name",
      col_span: 2,
      filters: () => {
        const equals = { asset_class_2: "structured_product" };
        return { equals };
      },
    },
    {
      name: "underlying_name_contains",
      label: t("a5_derivative_underlyings.searchbox.underlying_name_contains", { defaultValue: "Underlying" }),
      type: "asyncAutocomplete",
      base_url: "a5/a5_static_data",
      column_name: "name",
      col_span: 2,
    },
    {
      name: "create",
      type: "dateRange",
      label: t("a5_derivative_underlyings.searchbox.create", { defaultValue: "Creation date" }),
      from: { name: "create_from" },
      to: { name: "create_to" },
      col_span: 2,
    },
  ];
  return (
    <FilterTable
      client={client}
      schema={filterA5DerivativeUnderlyingsSchema}
      tableName="a5_derivative_underlyings"
      fields={fields}
      columns={2}
    />
  );
}
